// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-calendar-category .v-calendar-category__column,
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__column-header {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__head {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__intervals-head {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__intervals-body {
  background: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}

:where(.vuetify-styles) .v-calendar-category {
  overflow: auto;
  position: relative;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__category {
  text-align: center;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__day-container {
  width: min-content;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__day-container .v-calendar-category__columns {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__day-body {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__head {
  flex-direction: row;
  width: min-content;
  min-width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily_head-day {
  width: auto;
  position: unset;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__intervals-head {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 2;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily_head-weekday {
  position: sticky;
  left: 50%;
  width: 50px;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily_head-day-label {
  width: 56px;
  position: sticky;
  left: 50%;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__day {
  min-width: 200px;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__intervals-body {
  position: sticky;
  left: 0;
  z-index: 1;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__interval:last-of-type::after {
  display: none;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__body {
  overflow: visible;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__body .v-calendar-daily__scroll-area {
  overflow-y: visible;
  flex: none;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-daily__pane {
  overflow-y: visible;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__columns {
  display: flex;
  width: min-content;
  min-width: 100%;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__columns .v-calendar-category__column,
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
  flex: 1 1 auto;
  width: 0;
  position: relative;
}
:where(.vuetify-styles) .v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
  min-width: 200px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCalendar/VCalendarCategory.css"],"names":[],"mappings":"AAAA;;EAEE,4EAA4E;AAC9E;AACA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;AACR;AACA;EACE,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".v-calendar-category .v-calendar-category__column,\n.v-calendar-category .v-calendar-category__column-header {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-category .v-calendar-daily__head {\n  background: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-category .v-calendar-daily__intervals-head {\n  background: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-category .v-calendar-daily__intervals-body {\n  background: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n}\n\n.v-calendar-category {\n  overflow: auto;\n  position: relative;\n}\n.v-calendar-category .v-calendar-category__category {\n  text-align: center;\n}\n.v-calendar-category .v-calendar-daily__day-container {\n  width: min-content;\n}\n.v-calendar-category .v-calendar-daily__day-container .v-calendar-category__columns {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n}\n.v-calendar-category .v-calendar-daily__day-body {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n.v-calendar-category .v-calendar-daily__head {\n  flex-direction: row;\n  width: min-content;\n  min-width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n.v-calendar-category .v-calendar-daily_head-day {\n  width: auto;\n  position: unset;\n}\n.v-calendar-category .v-calendar-daily__intervals-head {\n  position: sticky;\n  left: 0;\n  top: 0;\n  z-index: 2;\n}\n.v-calendar-category .v-calendar-daily_head-weekday {\n  position: sticky;\n  left: 50%;\n  width: 50px;\n}\n.v-calendar-category .v-calendar-daily_head-day-label {\n  width: 56px;\n  position: sticky;\n  left: 50%;\n}\n.v-calendar-category .v-calendar-daily__day {\n  min-width: 200px;\n}\n.v-calendar-category .v-calendar-daily__intervals-body {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n}\n.v-calendar-category .v-calendar-daily__interval:last-of-type::after {\n  display: none;\n}\n.v-calendar-category .v-calendar-daily__body {\n  overflow: visible;\n}\n.v-calendar-category .v-calendar-daily__body .v-calendar-daily__scroll-area {\n  overflow-y: visible;\n  flex: none;\n}\n.v-calendar-category .v-calendar-daily__pane {\n  overflow-y: visible;\n}\n.v-calendar-category .v-calendar-category__columns {\n  display: flex;\n  width: min-content;\n  min-width: 100%;\n}\n.v-calendar-category .v-calendar-category__columns .v-calendar-category__column,\n.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {\n  flex: 1 1 auto;\n  width: 0;\n  position: relative;\n}\n.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {\n  min-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
